import { memo } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import ThumbUp from 'svg/thumb-up.svg';
import ThumbDown from 'svg/thumb-down.svg';

import { InfoTooltip } from 'components/v3';

import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { feedbackStates, setFeedback } from 'store/modules/recentFeedback';

import styles from '../message.scss';

const FeedbackButtons = memo(
  ({ answerId, messageId, questionId, localQuestionId, isFollowUp, feedback = feedbackStates.NONE }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isFeedbackPositive = feedback === feedbackStates.POS;
    const isFeedbackNegative = feedback === feedbackStates.NEG;

    const handleFeedbackClick = isPositive =>
      dispatch(setFeedback(answerId, messageId, questionId, localQuestionId, isPositive, isFollowUp, feedback));
    return (
      <>
        <span className={styles.separator}>•</span>
        <InfoTooltip text={t('tooltip.give-positive-feedback')}>
          <div className={styles.iconButtonContainer}>
            <ThumbUp
              className={clsx(
                styles.iconButtonIcon,
                styles.iconThumbsUp,
                isFeedbackPositive ? styles.iconPositive : ''
              )}
              onClick={() => handleFeedbackClick(true)}
            />
          </div>
        </InfoTooltip>
        <InfoTooltip text={t('tooltip.give-negative-feedback')}>
          <div className={styles.iconButtonContainer}>
            <ThumbDown
              className={clsx(
                styles.iconButtonIcon,
                styles.iconThumbsDown,
                isFeedbackNegative ? styles.iconNegative : ''
              )}
              onClick={() => handleFeedbackClick(false)}
            />
          </div>
        </InfoTooltip>
      </>
    );
  }
);

export default memo(FeedbackButtons);

FeedbackButtons.propTypes = {
  answerId: PropTypes.string,
  messageId: PropTypes.string,
  questionId: PropTypes.string,
  localQuestionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isFollowUp: PropTypes.bool,
  feedback: PropTypes.string
};
